var RegexValidation = /** @class */ (function () {
    function RegexValidation() {
    }
    RegexValidation.prototype.validate = function (regex, x) {
        var result = regex.exec(x);
        return result ? result[0] === x : false;
    };
    RegexValidation.prototype.canValidate = function (claims) {
        return true;
    };
    return RegexValidation;
}());
export { RegexValidation };
